import React from 'react';
import Picture from '../../components/ui/Picture/Picture';

export default function ProductPreview({
  title,
  color,
  image,
}: {
  title: string,
  color: string,
  image: any,
}) {
  return (
    <div className="flex items-center mb-4 sm:mb-6">
      <div className="w-20 sm:w-23 aspect-5/3.75 p-2 rounded border border-light-grey-2 bg-white mr-3 sm:mr-4.5">
        {image && (
          <Picture image={image} loading="eager" classes="w-full h-full object-contain" />
        )}
      </div>
      <div className="flex-1.0">
        <h4 className="font-semibold text-sm md:text-base">{title}</h4>
        <span className="text-dark-shade font-light text-xs md:text-sm">{color}</span>
      </div>
    </div>
  );
}
